// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_qz-0";